// extracted by mini-css-extract-plugin
export default {"root":"TextArea_root__ve7Pn","input":"TextArea_input__oOLXB"};